class Setting {
  async get() {
    const data = await fetch(`${process.env.REACT_APP_API_URL}/settings`, {
      headers: {
        'x-access-token': localStorage.getItem('token')
      }
    });
    return await data.json();
  }

  async addUpdate(settings) {
    for (const setting of settings) {
      await fetch(`${process.env.REACT_APP_API_URL}/settings/${setting.id || ''}`, {
        method: setting.id ? 'PUT' : 'POST',
        headers: {
          'Content-Type': 'application/json',
          'x-access-token': localStorage.getItem('token')
        },
        body: JSON.stringify(setting)
      });
    }
    
    return await this.get();
  }
}

module.exports = new Setting();